var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Animated, Platform, TouchableWithoutFeedback, } from 'react-native';
import { useSwitchStyle } from './style';
export function Switch(props) {
    const { checked, disabled = false, checkedChildren, onChange, onPress, } = props || {};
    const [state] = useState({
        translateX: new Animated.Value(checked ? 20 : 1),
    });
    const { switchStyle } = useSwitchStyle();
    useEffect(() => {
        Animated.timing(state.translateX, {
            toValue: !checked ? 1 : 20,
            useNativeDriver: Platform.OS !== 'web',
            duration: 300,
        }).start();
    }, [checked]);
    function handlePress(e) {
        return __awaiter(this, void 0, void 0, function* () {
            onPress === null || onPress === void 0 ? void 0 : onPress(e);
            if (disabled)
                return;
            onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
        });
    }
    return (React.createElement(TouchableWithoutFeedback, { style: {
            alignSelf: 'baseline',
        }, onPress: handlePress },
        React.createElement(Animated.View, { style: [
                { opacity: disabled ? 0.6 : 1 },
                switchStyle.track,
                checked
                    ? switchStyle.trackChecked
                    : switchStyle.trackUnchecked,
            ] },
            checked ? checkedChildren : null,
            React.createElement(Animated.View, { style: [
                    switchStyle.roundWhite,
                    {
                        transform: [
                            {
                                translateX: state.translateX,
                            },
                        ],
                    },
                ] }))));
}
export default Switch;
